import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQuery } from "../api/admin";
import { ApiError } from "../api/client";
import type { Me } from "../api/types";
import { isAppPath, landingPath, leaveFor } from "../lib/modeSwitch";

// `/` sends a member to a mode (spec 2.4, story CA8): Admin here, App by loading `/app`.
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    let me: Me;
    try {
      me = await context.queryClient.ensureQueryData(meQuery);
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) throw redirect({ to: "/signin" });
      throw e;
    }
    const to = landingPath(me);
    if (isAppPath(to)) await leaveFor(to);
    throw redirect({ href: to, replace: true });
  },
});
